import styled from 'styled-components';
import {MinMaxBetAmountDefaultBox} from './min-max-bet-amount.default.box';


export const MinMaxBetAmountCisBox = styled(MinMaxBetAmountDefaultBox)`
`;
